// src/auth/logout.js
export function logout(navigate) {
  // Clear all authentication data
  localStorage.clear();
  sessionStorage.clear();
  // Remove cookies (simple version, for all cookies)
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  // Redirect to login and replace history
  navigate("/login", { replace: true });
}
